"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchEngineFactory = void 0;
const SearchByID_1 = require("./SearchByID");
const SearchAll_1 = require("./SearchAll");
const SearchByFilter_1 = require("./SearchByFilter");
class SearchEngineFactory {
}
exports.SearchEngineFactory = SearchEngineFactory;
SearchEngineFactory.produce = (filter) => {
    if (filter === null || filter === void 0 ? void 0 : filter.pushApplicationID) {
        return new SearchByID_1.SearchByID(filter);
    }
    if (!filter || Object.keys(filter).length === 0 || (Object.keys(filter).length === 1 && 'page' in filter)) {
        // no filters
        return new SearchAll_1.SearchAll();
    }
    return new SearchByFilter_1.SearchByFilter(filter);
};
//# sourceMappingURL=SearchEngineFactory.js.map